import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoin, faFireAlt, faTruck } from "@fortawesome/pro-solid-svg-icons";
import { useTheme } from "styled-components";
import SmartImage from "../SmartImage";
import BadgeEsgotado from "../BadgeEsgotado";

function ProdutoVertical({
  id,
  nome,
  foto = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAWlBMVEXv8fNod4f19vhkdIRcbX52g5KPmqX29/iYoq3l6OuCj5vd4eTr7fBfcIFaa33M0dbBx82SnKe7wchtfIt8iZejq7TU2N2Ik6CwuL/Gy9Gqsrqbpa/P1NmhqrNz0egRAAADBklEQVR4nO3c63KqMBRAYUiwwUvEete27/+ax1tVAqhwEtnprO+XM62Oyw2CGTFJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJe6Mb5vqL7jjsws/wgln/dddzBZZjocuxj2HaiWNg1JL/oO3GVBA9PUzvvdF80q7AgPQ/zot1DlOnThyFBIIYWvFtrMK3mFdj30aWzFFWZjr+/qE4mFXh+YwrehsDMK34bCzmIoVEad1nC6PbD8QpXMNwOdDvKi2xMUX2jm2h7/onU2WHcZo/RCld8WN3TWZR1CeKH6LK1tTGftE2UXqpmzPGXbLwnKLkzcT8X6s/UQRReqWWX9LWs9RNGF5qOysmFb74miC9XCDUzt6k8VJtXC9jsihW9Tu5Uuq/vhvlKokuGjc1bRhWZVLdw5MWq8mU6zfNL4wKILk/W0spW6dyvOZ61p4wKd7EIzcoZot+UQVVxeA62bEmUXJuPyIV8PnDsVtxXtpikKL1S7++1U6/IZzV1g8xSFFx4i9HWMdjksNZQCGxOlFyZq8jW1VmubpZV90PngUZ8ovvDYuNt//Wy/1ZPAhsQICo+rUMa4T70msP7tJorCun8vKofKhilGWlg7wfopxlnYMMHaKUZZ2DjBuinGWPgwsDLFCAufBLqJ8RU+DXQ21OgKXwgsTzG2wpcCj1O8nsJGVvjgMNE0xbgKX5zgeYqXxKgKX57geYrnDTWmwhYTvJtiRIUtA3/fbuIpbB14mWI0hR0Cz1OMpbBT4CkxiaOwY+BpQ42isNVhwk283hJc2HmC5Va5hf8xwTgK/UxQcKGvQLGF3gKlFvoLFFroMVBmoc9AkYWeDhNyC1Xh9aJLeYV+Jyiw0Os+KLHQe6C0Qv+BwgoDBMoqDBEoqtCECJRUOPz2e5gQV2jnYa7qllOYBvr5CEGFgVBIIYXPmJ/ghZueZ+hexOWd+w3q9ycuwg5R2377DsapDflbX7rTFah+TbajQSij/aT/wNNF26FUvoELAAAAAAAAAAAAAAAAAAAAAAAAAAAA4G/4B9L3P1vg3y4/AAAAAElFTkSuQmCC",
  preco,
  status = "active",
  destaque = false,
  estoque = false,
  quantidadeMinima = 1,
  onClick = () => {},
  border = false,
}) {
  const theme = useTheme();
  const preVenda = status === "pre_lancamento";
  // estoque abaixo da quantidade minima de compra = indisponivel
  const esgotado = !preVenda && estoque < (quantidadeMinima || 1);
  const precoOculto = preVenda || esgotado;
  const ultimas = !precoOculto && estoque < 5;

  return (
    <CardWrapper onClick={onClick}>
      <Imagem>
        <SmartImage src={foto} height={180} width={180} alt={nome} />
      </Imagem>
      <InfoBottom>
        <Nome>{nome}</Nome>
        {!precoOculto && (
          <Preco>
            <FontAwesomeIcon icon={faCoin} color={theme.primary} /> {preco}
          </Preco>
        )}
        {destaque && (
          <Badge $type="destaque">
            <FontAwesomeIcon icon={faFireAlt} /> Destaque
          </Badge>
        )}
        {ultimas && (
          <Badge $type="ultimas">
            {estoque === 1
              ? `Ultima unidade`
              : `Ultimas ${estoque} unidades`}
          </Badge>
        )}
        {preVenda && <BadgeEsgotado />}
        {esgotado && <Badge $type="esgotado">ESGOTADO</Badge>}
      </InfoBottom>
    </CardWrapper>
  );
}

const CardWrapper = styled.div`
  padding: 16px;
  cursor: pointer;
  background: #fff;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  transition: box-shadow 0.15s;
  display: flex;
  flex-direction: column;
  height: 100%;
  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
    z-index: 1;
    position: relative;
  }
`;

const InfoBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
`;

const Imagem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1;
  margin-bottom: 8px;
  & img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
  }
`;

const Nome = styled.div`
  color: #333;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Preco = styled.div`
  color: #333;
  font-size: 22px;
  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const Shipping = styled.div`
  font-size: 12px;
  color: #00a650;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 3px;
  width: fit-content;
  background: ${props =>
    props.$type === "destaque" ? "#fff3ef" :
    props.$type === "ultimas" ? "#00a650" :
    props.$type === "esgotado" ? "#9e9e9e" : "#f5f5f5"};
  color: ${props =>
    props.$type === "destaque" ? "#ff5900" :
    props.$type === "ultimas" ? "#fff" :
    props.$type === "esgotado" ? "#fff" : "#999"};
`;

export default ProdutoVertical;
